<script>
import { CSAT_RATINGS } from 'shared/constants/messages';

// Bot conversation labels mapping
const BOT_RATING_LABELS = {
  dissatisfied: 'Unsatisfied',
  neutral: 'Undecided',
  satisfied: 'Love it',
};

export default {
  name: 'ReportFiltersRatings',
  props: {
    conversationType: {
      type: Object,
      default: null,
    },
  },
  emits: ['ratingFilterSelection'],
  data() {
    return {
      selectedOption: null,
      greenSmileyImage: '/brand-assets/green_smiley_emoji.png',
    };
  },
  computed: {
    isBotConversation() {
      return this.conversationType?.id === 'bot';
    },
    options() {
      return [...CSAT_RATINGS].reverse().map(option => {
        if (this.isBotConversation) {
          return {
            key: option.key,
            value: option.value,
            color: option.color,
            emoji: option.emoji,
            label: BOT_RATING_LABELS[option.key],
            showGreenSmiley: option.key === 'satisfied',
          };
        }
        return {
          key: option.key,
          value: option.value,
          color: option.color,
          emoji: option.emoji,
          label: this.$t(option.translationKey),
          showGreenSmiley: option.key === 'satisfied',
        };
      });
    },
  },
  methods: {
    handleInput(selectedRating) {
      this.$emit('ratingFilterSelection', selectedRating);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :option-height="24"
      :placeholder="$t('FORMS.MULTISELECT.SELECT_ONE')"
      :options="options"
      :show-labels="false"
      track-by="value"
      label="label"
      @update:model-value="handleInput"
    >
      <template #singleLabel="{ option }">
        <span style="display: inline-flex; align-items: center; gap: 4px;">
          <img
            v-if="option.showGreenSmiley"
            :src="greenSmileyImage"
            alt="Love it"
            style="width: 1.2em; height: 1.2em; object-fit: contain; flex-shrink: 0;"
          />
          <span v-else style="line-height: 1; flex-shrink: 0;">{{ option.emoji }}</span>
          <span>{{ option.label }}</span>
        </span>
      </template>
      <template #option="{ option }">
        <span style="display: inline-flex; align-items: center; gap: 4px;">
          <img
            v-if="option.showGreenSmiley"
            :src="greenSmileyImage"
            alt="Love it"
            style="width: 1.2em; height: 1.2em; object-fit: contain; flex-shrink: 0;"
          />
          <span v-else style="line-height: 1; flex-shrink: 0;">{{ option.emoji }}</span>
          <span>{{ option.label }}</span>
        </span>
      </template>
    </multiselect>
  </div>
</template>
